// extracted by mini-css-extract-plugin
export default {"rating":"gJ-z","numberOfStars":"hJ-z","count":"iJ-z","barGraphSpacing":"jJ-z","barGraph":"kJ-z"};